import factory from './icon';
import Svg from './glyphs/ic_check_24px.svg';

export default factory(Svg);
